import { ThemeColors } from '../../../'

export interface AudioPlayerColors {
  Background: ThemeColors
  BoxShadow: ThemeColors
  ControlButton: {
    Background: {
      Default: ThemeColors
    }
    Icon: {
      Hover: ThemeColors
    }
  }
  PlayButton: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
  PauseButton: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
  Title: {
    FontColor: ThemeColors
    IconColor: ThemeColors
  }
  Handle: {
    Background: ThemeColors
    Border: ThemeColors
  }
  Track: {
    Played: ThemeColors
    Unplayed: ThemeColors
  }
  Timestamp: {
    FontColor: ThemeColors
  }
}

export const audioPlayerColors: AudioPlayerColors = {
  Background: {
    default: 'bg.panel',
  },
  BoxShadow: {
    default: 'overlay.dark',
  },
  ControlButton: {
    Background: {
      Default: {
        default: 'transparent',
      },
    },
    Icon: {
      Hover: {
        default: 'fg.default',
      },
    },
  },
  PlayButton: {
    Background: {
      Default: {
        default: 'bg.muted',
      },
      Hover: {
        default: 'bg.emphasized',
      },
      Active: {
        default: 'brand.muted',
      },
    },
  },
  PauseButton: {
    Background: {
      Default: {
        default: 'brand.solid',
      },
      Hover: {
        default: 'brand.emphasized',
      },
      Active: {
        default: 'brand.solid',
      },
    },
  },
  Title: {
    FontColor: {
      default: 'fg.default',
    },
    IconColor: {
      default: 'fg.default',
    },
  },
  Handle: {
    Background: {
      default: 'brand.solid',
    },
    Border: {
      default: 'bg.panel',
    },
  },
  Track: {
    Played: {
      default: 'brand.emphasized',
    },
    Unplayed: {
      default: 'bg.emphasized',
    },
  },
  Timestamp: {
    FontColor: {
      default: 'fg.default',
    },
  },
}
